import PrimeVue from 'primevue/config'

import { Form } from '@primevue/forms'

import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import Column from 'primevue/column'
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmationService from 'primevue/confirmationservice'
import DataTable from 'primevue/datatable'
import DatePicker from 'primevue/datepicker'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import MultiSelect from 'primevue/multiselect'
import RadioButton from 'primevue/radiobutton'
import Select from 'primevue/select'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'

import ro from './primevue-ro.json'
import Aura from '@primevue/themes/aura'

export default (app) => {
  app.use(PrimeVue, {
    locale: ro,
    theme: {
      preset: Aura,
      options: {
        prefix: 'p',
        darkModeSelector: false,
        cssLayer: false,
      },
    },
    pt: {
      inputtext: {
        root: {
          class: 'input',
        },
      },
      multiselect: {
        root: {
          class: 'button is-medium',
        },
        dropdown: {
          class: 'icon is-icon-3',
        },
        option: {
          class: 'is-body-small has-text-weight-medium',
        },
      },
      select: {
        label: {},
        option: {
          class: 'is-label-small',
        },
      },
      toast: {
        detail: {
          class: 'is-body-small',
        },
        summary: {
          class: 'is-body-small',
        },
      },
    },
  })

  app.use(ConfirmationService)
  app.use(ToastService)

  app.component('Button', Button)
  app.component('Checkbox', Checkbox)
  app.component('Column', Column)
  app.component('ConfirmDialog', ConfirmDialog)
  app.component('DatePicker', DatePicker)
  app.component('DataTable', DataTable)
  app.component('Dialog', Dialog)
  app.component('InputText', InputText)
  app.component('InputNumber', InputNumber)
  app.component('MultiSelect', MultiSelect)
  app.component('RadioButton', RadioButton)
  app.component('Select', Select)
  app.component('Toast', Toast)

  app.component('Form', Form)
}
